// removed by extract-text-webpack-plugin
module.exports = {"billingHeaderFont":"billingHeaderFont___31EIs","vpPaymentInfoHeader":"vpPaymentInfoHeader___2AYNi","billingFont":"billingFont___3H8Cl","vpPaymentInfoItem":"vpPaymentInfoItem___C2EWB","vpPaymentInfoWrapper":"vpPaymentInfoWrapper___2pV0T","vpPaymentInfoUpdateAction":"vpPaymentInfoUpdateAction___JeKMU"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpPaymentInfo.module.less
// module id = 3178
// module chunks = 33